import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import PropTypes from 'prop-types';
import React from 'react';
import { Animated, Platform, StyleSheet, View, SafeAreaView } from 'react-native';
import { ActionSheetProvider } from '@expo/react-native-action-sheet';
import moment from 'moment';
import uuid from 'uuid';
import { isIphoneX } from 'react-native-iphone-x-helper';
import * as utils from './utils';
import Actions from './Actions';
import Avatar from './Avatar';
import Bubble from './Bubble';
import SystemMessage from './SystemMessage';
import MessageImage from './MessageImage';
import MessageText from './MessageText';
import Composer from './Composer';
import Day from './Day';
import InputToolbar from './InputToolbar';
import LoadEarlier from './LoadEarlier';
import Message from './Message';
import MessageContainer from './MessageContainer';
import Send from './Send';
import Time from './Time';
import GiftedAvatar from './GiftedAvatar';
import { MIN_COMPOSER_HEIGHT, MAX_COMPOSER_HEIGHT, DEFAULT_PLACEHOLDER, TIME_FORMAT, DATE_FORMAT } from './Constant';

var GiftedChat =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GiftedChat, _React$Component);

  function GiftedChat(props) {
    var _this;

    _classCallCheck(this, GiftedChat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GiftedChat).call(this, props));
    _this._isMounted = false;
    _this._keyboardHeight = 0;
    _this._bottomOffset = 0;
    _this._maxHeight = undefined;
    _this._isFirstLayout = true;
    _this._locale = 'en';
    _this.invertibleScrollViewProps = undefined;
    _this._actionSheetRef = undefined;
    _this._messageContainerRef = React.createRef();
    _this.state = {
      isInitialized: false,
      composerHeight: _this.props.minComposerHeight,
      messagesContainerHeight: undefined,
      typingDisabled: false,
      text: undefined,
      messages: undefined
    };

    _this.getLocale = function () {
      return _this._locale;
    };

    _this.safeAreaIphoneX = function (bottomOffset) {
      if (isIphoneX()) {
        return bottomOffset === _this._bottomOffset ? 33 : bottomOffset;
      }

      return bottomOffset;
    };

    _this.onKeyboardWillShow = function (e) {
      _this.setIsTypingDisabled(true);

      _this.setKeyboardHeight(e.endCoordinates ? e.endCoordinates.height : e.end.height);

      _this.setBottomOffset(_this.safeAreaIphoneX(_this.props.bottomOffset));

      var newMessagesContainerHeight = _this.getMessagesContainerHeightWithKeyboard();

      if (_this.props.isAnimated === true) {
        Animated.timing(_this.state.messagesContainerHeight, {
          toValue: newMessagesContainerHeight,
          duration: 210
        }).start();
      } else {
        _this.setState({
          messagesContainerHeight: newMessagesContainerHeight
        });
      }
    };

    _this.onKeyboardWillHide = function (_e) {
      _this.setIsTypingDisabled(true);

      _this.setKeyboardHeight(0);

      _this.setBottomOffset(0);

      var newMessagesContainerHeight = _this.getBasicMessagesContainerHeight();

      if (_this.props.isAnimated === true) {
        Animated.timing(_this.state.messagesContainerHeight, {
          toValue: newMessagesContainerHeight,
          duration: 210
        }).start();
      } else {
        _this.setState({
          messagesContainerHeight: newMessagesContainerHeight
        });
      }
    };

    _this.onKeyboardDidShow = function (e) {
      if (Platform.OS === 'android') {
        _this.onKeyboardWillShow(e);
      }

      _this.setIsTypingDisabled(false);
    };

    _this.onKeyboardDidHide = function (e) {
      if (Platform.OS === 'android') {
        _this.onKeyboardWillHide(e);
      }

      _this.setIsTypingDisabled(false);
    };

    _this.onSend = function () {
      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var shouldResetInputToolbar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!Array.isArray(messages)) {
        messages = [messages];
      }

      var newMessages = messages.map(function (message) {
        return _objectSpread({}, message, {
          user: _this.props.user,
          createdAt: new Date(),
          _id: _this.props.messageIdGenerator && _this.props.messageIdGenerator()
        });
      });

      if (shouldResetInputToolbar === true) {
        _this.setIsTypingDisabled(true);

        _this.resetInputToolbar();
      }

      if (_this.props.onSend) {
        _this.props.onSend(newMessages);
      }

      if (shouldResetInputToolbar === true) {
        setTimeout(function () {
          if (_this.getIsMounted() === true) {
            _this.setIsTypingDisabled(false);
          }
        }, 100);
      }
    };

    _this.onInputSizeChanged = function (size) {
      var newComposerHeight = Math.max(_this.props.minComposerHeight, Math.min(_this.props.maxComposerHeight, size.height));

      var newMessagesContainerHeight = _this.getMessagesContainerHeightWithKeyboard(newComposerHeight);

      _this.setState({
        composerHeight: newComposerHeight,
        messagesContainerHeight: _this.prepareMessagesContainerHeight(newMessagesContainerHeight)
      });
    };

    _this.onInputTextChanged = function (text) {
      if (_this.getIsTypingDisabled()) {
        return;
      }

      if (_this.props.onInputTextChanged) {
        _this.props.onInputTextChanged(text);
      } // Only set state if it's not being overridden by a prop.


      if (_this.props.text === undefined) {
        _this.setState({
          text: text
        });
      }
    };

    _this.onInitialLayoutViewLayout = function (e) {
      var layout = e.nativeEvent.layout;

      if (layout.height <= 0) {
        return;
      }

      _this.notifyInputTextReset();

      _this.setMaxHeight(layout.height);

      var newComposerHeight = _this.props.minComposerHeight;

      var newMessagesContainerHeight = _this.getMessagesContainerHeightWithKeyboard(newComposerHeight);

      var initialText = _this.props.initialText || '';

      _this.setState({
        isInitialized: true,
        text: _this.getTextFromProp(initialText),
        composerHeight: newComposerHeight,
        messagesContainerHeight: _this.prepareMessagesContainerHeight(newMessagesContainerHeight)
      });
    };

    _this.onMainViewLayout = function (e) {
      // fix an issue when keyboard is dismissing during the initialization
      var layout = e.nativeEvent.layout;

      if (_this.getMaxHeight() !== layout.height || _this.getIsFirstLayout() === true) {
        _this.setMaxHeight(layout.height);

        _this.setState({
          messagesContainerHeight: _this.prepareMessagesContainerHeight(_this.getBasicMessagesContainerHeight())
        });
      }

      if (_this.getIsFirstLayout() === true) {
        _this.setIsFirstLayout(false);
      }
    };

    _this.invertibleScrollViewProps = {
      inverted: _this.props.inverted,
      keyboardShouldPersistTaps: _this.props.keyboardShouldPersistTaps,
      onKeyboardWillShow: _this.onKeyboardWillShow,
      onKeyboardWillHide: _this.onKeyboardWillHide,
      onKeyboardDidShow: _this.onKeyboardDidShow,
      onKeyboardDidHide: _this.onKeyboardDidHide
    };
    return _this;
  }

  _createClass(GiftedChat, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        actionSheet: function actionSheet() {
          return _this2._actionSheetRef.getContext();
        },
        getLocale: this.getLocale
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          messages = _this$props.messages,
          text = _this$props.text;
      this.setIsMounted(true);
      this.initLocale();
      this.setMessages(messages || []);
      this.setTextFromProp(text);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setIsMounted(false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          messages = _this$props2.messages,
          text = _this$props2.text;

      if (messages && prevProps.messages && messages.length !== prevProps.messages.length) {
        this.setMessages(messages || []);
        setTimeout(function () {
          return _this3.scrollToBottom(false);
        }, 200);
      }

      if (text !== prevProps.text) {
        this.setTextFromProp(text);
      }
    }
  }, {
    key: "initLocale",
    value: function initLocale() {
      if (this.props.locale === null || moment.locales().indexOf(this.props.locale || 'en') === -1) {
        this.setLocale('en');
      } else {
        this.setLocale(this.props.locale || 'en');
      }
    }
  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      this._locale = locale;
    }
  }, {
    key: "setTextFromProp",
    value: function setTextFromProp(textProp) {
      // Text prop takes precedence over state.
      if (textProp !== undefined && textProp !== this.state.text) {
        this.setState({
          text: textProp
        });
      }
    }
  }, {
    key: "getTextFromProp",
    value: function getTextFromProp(fallback) {
      if (this.props.text === undefined) {
        return fallback;
      }

      return this.props.text;
    }
  }, {
    key: "setMessages",
    value: function setMessages(messages) {
      this.setState({
        messages: messages
      });
    }
  }, {
    key: "getMessages",
    value: function getMessages() {
      return this.state.messages;
    }
  }, {
    key: "setMaxHeight",
    value: function setMaxHeight(height) {
      this._maxHeight = height;
    }
  }, {
    key: "getMaxHeight",
    value: function getMaxHeight() {
      return this._maxHeight;
    }
  }, {
    key: "setKeyboardHeight",
    value: function setKeyboardHeight(height) {
      this._keyboardHeight = height;
    }
  }, {
    key: "getKeyboardHeight",
    value: function getKeyboardHeight() {
      if (Platform.OS === 'android' && !this.props.forceGetKeyboardHeight) {
        // For android: on-screen keyboard resized main container and has own height.
        // @see https://developer.android.com/training/keyboard-input/visibility.html
        // So for calculate the messages container height ignore keyboard height.
        return 0;
      }

      return this._keyboardHeight;
    }
  }, {
    key: "setBottomOffset",
    value: function setBottomOffset(value) {
      this._bottomOffset = value;
    }
  }, {
    key: "getBottomOffset",
    value: function getBottomOffset() {
      return this._bottomOffset;
    }
  }, {
    key: "setIsFirstLayout",
    value: function setIsFirstLayout(value) {
      this._isFirstLayout = value;
    }
  }, {
    key: "getIsFirstLayout",
    value: function getIsFirstLayout() {
      return this._isFirstLayout;
    }
  }, {
    key: "setIsTypingDisabled",
    value: function setIsTypingDisabled(value) {
      this.setState({
        typingDisabled: value
      });
    }
  }, {
    key: "getIsTypingDisabled",
    value: function getIsTypingDisabled() {
      return this.state.typingDisabled;
    }
  }, {
    key: "setIsMounted",
    value: function setIsMounted(value) {
      this._isMounted = value;
    }
  }, {
    key: "getIsMounted",
    value: function getIsMounted() {
      return this._isMounted;
    }
  }, {
    key: "getMinInputToolbarHeight",
    value: function getMinInputToolbarHeight() {
      return this.props.renderAccessory ? this.props.minInputToolbarHeight * 2 : this.props.minInputToolbarHeight;
    }
  }, {
    key: "calculateInputToolbarHeight",
    value: function calculateInputToolbarHeight(composerHeight) {
      return composerHeight + (this.getMinInputToolbarHeight() - this.props.minComposerHeight);
    }
    /**
     * Returns the height, based on current window size, without taking the keyboard into account.
     */

  }, {
    key: "getBasicMessagesContainerHeight",
    value: function getBasicMessagesContainerHeight() {
      var composerHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.composerHeight;
      return this.getMaxHeight() - this.calculateInputToolbarHeight(composerHeight);
    }
    /**
     * Returns the height, based on current window size, taking the keyboard into account.
     */

  }, {
    key: "getMessagesContainerHeightWithKeyboard",
    value: function getMessagesContainerHeightWithKeyboard() {
      var composerHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.composerHeight;
      return this.getBasicMessagesContainerHeight(composerHeight) - this.getKeyboardHeight() + this.getBottomOffset();
    }
  }, {
    key: "prepareMessagesContainerHeight",
    value: function prepareMessagesContainerHeight(value) {
      if (this.props.isAnimated === true) {
        return new Animated.Value(value);
      }

      return value;
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this._messageContainerRef && this._messageContainerRef.current) {
        var inverted = this.props.inverted;

        if (!inverted) {
          this._messageContainerRef.current.scrollToEnd({
            animated: animated
          });
        } else {
          this._messageContainerRef.current.scrollToOffset({
            offset: 0,
            animated: animated
          });
        }
      }
    }
  }, {
    key: "renderMessages",
    value: function renderMessages() {
      var AnimatedView = this.props.isAnimated === true ? Animated.View : View;
      return React.createElement(AnimatedView, {
        style: {
          height: this.state.messagesContainerHeight
        }
      }, React.createElement(MessageContainer, _extends({}, this.props, {
        invertibleScrollViewProps: this.invertibleScrollViewProps,
        messages: this.getMessages(),
        forwardRef: this._messageContainerRef
      })), this.renderChatFooter());
    }
  }, {
    key: "resetInputToolbar",
    value: function resetInputToolbar() {
      if (this.textInput) {
        this.textInput.clear();
      }

      this.notifyInputTextReset();
      var newComposerHeight = this.props.minComposerHeight;
      var newMessagesContainerHeight = this.getMessagesContainerHeightWithKeyboard(newComposerHeight);
      this.setState({
        text: this.getTextFromProp(''),
        composerHeight: newComposerHeight,
        messagesContainerHeight: this.prepareMessagesContainerHeight(newMessagesContainerHeight)
      });
    }
  }, {
    key: "focusTextInput",
    value: function focusTextInput() {
      if (this.textInput) {
        this.textInput.focus();
      }
    }
  }, {
    key: "notifyInputTextReset",
    value: function notifyInputTextReset() {
      if (this.props.onInputTextChanged) {
        this.props.onInputTextChanged('');
      }
    }
  }, {
    key: "renderInputToolbar",
    value: function renderInputToolbar() {
      var _this4 = this;

      var inputToolbarProps = _objectSpread({}, this.props, {
        text: this.getTextFromProp(this.state.text),
        composerHeight: Math.max(this.props.minComposerHeight, this.state.composerHeight),
        onSend: this.onSend,
        onInputSizeChanged: this.onInputSizeChanged,
        onTextChanged: this.onInputTextChanged,
        textInputProps: _objectSpread({}, this.props.textInputProps, {
          ref: function ref(textInput) {
            return _this4.textInput = textInput;
          },
          maxLength: this.getIsTypingDisabled() ? 0 : this.props.maxInputLength
        })
      });

      if (this.props.renderInputToolbar) {
        return this.props.renderInputToolbar(inputToolbarProps);
      }

      return React.createElement(InputToolbar, inputToolbarProps);
    }
  }, {
    key: "renderChatFooter",
    value: function renderChatFooter() {
      if (this.props.renderChatFooter) {
        return this.props.renderChatFooter();
      }

      return null;
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      if (this.props.renderLoading) {
        return this.props.renderLoading();
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (this.state.isInitialized === true) {
        return React.createElement(SafeAreaView, {
          style: styles.safeArea
        }, React.createElement(ActionSheetProvider, {
          ref: function ref(component) {
            return _this5._actionSheetRef = component;
          }
        }, React.createElement(View, {
          style: styles.container,
          onLayout: this.onMainViewLayout
        }, this.renderMessages(), this.renderInputToolbar())));
      }

      return React.createElement(View, {
        style: styles.container,
        onLayout: this.onInitialLayoutViewLayout
      }, this.renderLoading());
    }
  }], [{
    key: "append",
    value: function append() {
      var currentMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var messages = arguments.length > 1 ? arguments[1] : undefined;
      var inverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!Array.isArray(messages)) {
        messages = [messages];
      }

      return inverted ? messages.concat(currentMessages) : currentMessages.concat(messages);
    }
  }, {
    key: "prepend",
    value: function prepend() {
      var currentMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var messages = arguments.length > 1 ? arguments[1] : undefined;
      var inverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!Array.isArray(messages)) {
        messages = [messages];
      }

      return inverted ? currentMessages.concat(messages) : messages.concat(currentMessages);
    }
  }]);

  return GiftedChat;
}(React.Component);

GiftedChat.childContextTypes = {
  actionSheet: PropTypes.func,
  getLocale: PropTypes.func
};
GiftedChat.defaultProps = {
  messages: [],
  text: undefined,
  placeholder: DEFAULT_PLACEHOLDER,
  messageIdGenerator: function messageIdGenerator() {
    return uuid.v4();
  },
  user: {},
  onSend: function onSend() {},
  locale: null,
  timeFormat: TIME_FORMAT,
  dateFormat: DATE_FORMAT,
  isAnimated: Platform.select({
    ios: true,
    android: false,
    default: false
  }),
  loadEarlier: false,
  onLoadEarlier: function onLoadEarlier() {},
  isLoadingEarlier: false,
  renderLoading: null,
  renderLoadEarlier: null,
  renderAvatar: undefined,
  showUserAvatar: false,
  onPressAvatar: null,
  onLongPressAvatar: null,
  renderUsernameOnMessage: false,
  renderAvatarOnTop: false,
  renderBubble: null,
  renderSystemMessage: null,
  onLongPress: null,
  renderMessage: null,
  renderMessageText: null,
  renderMessageImage: null,
  imageProps: {},
  videoProps: {},
  lightboxProps: {},
  textInputProps: {},
  listViewProps: {},
  renderCustomView: null,
  isCustomViewBottom: false,
  renderDay: null,
  renderTime: null,
  renderFooter: null,
  renderChatFooter: null,
  renderInputToolbar: null,
  renderComposer: null,
  renderActions: null,
  renderSend: null,
  renderAccessory: null,
  onPressActionButton: null,
  bottomOffset: 0,
  minInputToolbarHeight: 44,
  keyboardShouldPersistTaps: Platform.select({
    ios: 'never',
    android: 'always',
    default: 'never'
  }),
  onInputTextChanged: null,
  maxInputLength: null,
  forceGetKeyboardHeight: false,
  inverted: true,
  extraData: null,
  minComposerHeight: MIN_COMPOSER_HEIGHT,
  maxComposerHeight: MAX_COMPOSER_HEIGHT
};
GiftedChat.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object),
  text: PropTypes.string,
  initialText: PropTypes.string,
  placeholder: PropTypes.string,
  messageIdGenerator: PropTypes.func,
  user: PropTypes.object,
  onSend: PropTypes.func,
  locale: PropTypes.string,
  timeFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  isAnimated: PropTypes.bool,
  loadEarlier: PropTypes.bool,
  onLoadEarlier: PropTypes.func,
  isLoadingEarlier: PropTypes.bool,
  renderLoading: PropTypes.func,
  renderLoadEarlier: PropTypes.func,
  renderAvatar: PropTypes.func,
  showUserAvatar: PropTypes.bool,
  onPressAvatar: PropTypes.func,
  onLongPressAvatar: PropTypes.func,
  renderUsernameOnMessage: PropTypes.bool,
  renderAvatarOnTop: PropTypes.bool,
  isCustomViewBottom: PropTypes.bool,
  renderBubble: PropTypes.func,
  renderSystemMessage: PropTypes.func,
  onLongPress: PropTypes.func,
  renderMessage: PropTypes.func,
  renderMessageText: PropTypes.func,
  renderMessageImage: PropTypes.func,
  imageProps: PropTypes.object,
  videoProps: PropTypes.object,
  lightboxProps: PropTypes.object,
  renderCustomView: PropTypes.func,
  renderDay: PropTypes.func,
  renderTime: PropTypes.func,
  renderFooter: PropTypes.func,
  renderChatFooter: PropTypes.func,
  renderInputToolbar: PropTypes.func,
  renderComposer: PropTypes.func,
  renderActions: PropTypes.func,
  renderSend: PropTypes.func,
  renderAccessory: PropTypes.func,
  onPressActionButton: PropTypes.func,
  bottomOffset: PropTypes.number,
  minInputToolbarHeight: PropTypes.number,
  listViewProps: PropTypes.object,
  keyboardShouldPersistTaps: PropTypes.oneOf(['always', 'never', 'handled']),
  onInputTextChanged: PropTypes.func,
  maxInputLength: PropTypes.number,
  forceGetKeyboardHeight: PropTypes.bool,
  inverted: PropTypes.bool,
  textInputProps: PropTypes.object,
  extraData: PropTypes.object,
  minComposerHeight: PropTypes.number,
  maxComposerHeight: PropTypes.number,
  alignTop: PropTypes.bool
};
var styles = StyleSheet.create({
  container: {
    flex: 1
  },
  safeArea: {
    flex: 1
  }
});
export { GiftedChat, Actions, Avatar, Bubble, SystemMessage, MessageImage, MessageText, Composer, Day, InputToolbar, LoadEarlier, Message, MessageContainer, Send, Time, GiftedAvatar, utils };